import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { user } = useSelector(state => state.auth);

  // Routes that require admin authentication
  const isAdminRoute = location.pathname.includes('admin')
    || location.pathname.startsWith('/rpa')
    || location.pathname.startsWith('/cmmc');
  
  useEffect(() => {
    const checkAuth = async () => {
      if (user && user.isAuthenticated) {
        if (isAdminRoute && user.accountType !== 'Admin') {
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/check/session`, 
          { withCredentials: true }
        );
        
        if (response.data && response.data.isAuthenticated) {
          const userData = response.data.user;
          
          if (isAdminRoute && userData.accountType !== 'Admin') {
            setIsAuthenticated(false);
          } else {
            setIsAuthenticated(true);
          }
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [location.pathname, user, isAdminRoute]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return isAdminRoute 
      ? <Navigate to="/admin/form/11" state={{ from: location }} replace />
      : <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;





// import React, { useEffect, useState } from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import axios from 'axios';

// const PrivateRoute = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const location = useLocation();
//   const { user } = useSelector(state => state.auth);
  
//   useEffect(() => {
//     const checkAuth = async () => {
//       // First check Redux state
//       if (user && user.isAuthenticated) {
//         // For admin routes, check if user is an admin
//         if (location.pathname.includes('admin') && user.accountType !== 'Admin') {
//           setIsAuthenticated(false);
//         } else {
//           setIsAuthenticated(true);
//         }
//         setLoading(false);
//         return;
//       }

//       // If not in Redux state, check with the server
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API}/check/session`, 
//           { withCredentials: true }
//         );
        
//         if (response.data && response.data.isAuthenticated) {
//           const userData = response.data.user;
          
//           // For admin routes, verify admin account type
//           if (location.pathname.includes('admin') && userData.accountType !== 'Admin') {
//             setIsAuthenticated(false);
//           } else {
//             setIsAuthenticated(true);
//           }
//         } else {
//           setIsAuthenticated(false);
//         }
//       } catch (error) {
//         console.error('Auth check failed:', error);
//         setIsAuthenticated(false);
//       } finally {
//         setLoading(false);
//       }
//     };

//     checkAuth();
//   }, [location.pathname, user]);

//   if (loading) {
//     return (
//       <div style={{ 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center', 
//         height: '100vh' 
//       }}>
//         <div>Loading...</div>
//       </div>
//     );
//   }

//   if (!isAuthenticated) {
//     // Redirect to admin login for admin routes, or regular login for other routes
//     return location.pathname.includes('admin') 
//       ? <Navigate to="/admin/form/11" state={{ from: location }} replace />
//       : <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   return children;
// };

// export default PrivateRoute;